import { render, staticRenderFns } from "./GmbServicesCategorySelectBox.vue?vue&type=template&id=2793b3b4&scoped=true&"
import script from "./GmbServicesCategorySelectBox.vue?vue&type=script&lang=js&"
export * from "./GmbServicesCategorySelectBox.vue?vue&type=script&lang=js&"
import style0 from "./GmbServicesCategorySelectBox.vue?vue&type=style&index=0&id=2793b3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793b3b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
